import * as React from 'react';

import { Bone } from '@lightspeed/flame/Bone';
import { Box, Flex } from '@lightspeed/flame/Core';
import { IconExport } from '@lightspeed/flame/Icon/Export';
import { IconReceiptPrinter } from '@lightspeed/flame/Icon/ReceiptPrinter';

import { toBoolean } from 'root/apps/pages/utils/sanitize';

const Export: React.FC = () => {
  const [labelSize, setLabelSize] = React.useState();
  const { id: orderId, shipment_id: shipmentId } = window.history.getFilters();
  const { id: accountId } = window.merchantos.account;

  const exportUrl = `/admin/order/${orderId}/shipment/${shipmentId}/export`;
  const printLabelsUrl = labelSize
    ? `/API/Account/${accountId}/DisplayTemplate/OrderLineAsLabel.html?template=ItemLabel&print=1&labelSize=${labelSize}&shipmentID=${shipmentId}&orderID=${orderId}`
    : null;

  React.useEffect(() => {
    window.lsCloud.Options.get('label_size', { reload: true }).done((size) => {
      setLabelSize(size || '2.25x1.25');
    });
  }, []);

  return (
    <Flex mt={3}>
      <a
        href={exportUrl}
        data-test="shipment-export-url"
        target="_blank"
        rel="noopener noreferrer"
        style={{ color: 'black' }}
      >
        <IconExport /> &nbsp;Export
      </a>

      <Box ml={2} minWidth={80}>
        {printLabelsUrl ? (
          <a
            href=""
            onClick={(e) => {
              e.preventDefault();
              window.merchantos.print.handlePrintLabels({
                url: printLabelsUrl,
                target: '_blank',
                isZbpEnabled: toBoolean(
                  window.merchantos.session.sessData?.Shop?.zebraBrowserPrint
                ),
              });
            }}
            data-test="shipment-print-labels-url"
            rel="noopener noreferrer"
            style={{ color: 'black' }}
          >
            <IconReceiptPrinter /> &nbsp;Print labels
          </a>
        ) : (
          <Bone height="100%" />
        )}
      </Box>
    </Flex>
  );
};

export default Export;
